module.exports = __webpack_public_path__ + "static/media/62.e83ebd08.jpeg";